const Config = {
  MAX_ATTACHMENT_SIZE: 5000000,
};

export default Config;
